import axios from "axios";
import {
  MessageBox,
  Message
} from "element-ui";
import store from "@/store";
import router from "@/router";
import {
  getToken
} from "@/utils/auth";
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 20000, // request timeout
});
// request interceptor
service.interceptors.request.use(
  (config) => {
    if (config.genericToken) {
      // token 有值就传 没有值就不传
      if (store.getters.token) {
        config.headers["Authorization"] = "Bearer " + getToken();
      }
    } else if (store.getters.token && config.noToken !== true) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      // config.headers['X-Token'] = getToken()
      config.headers["Authorization"] = "Bearer " + getToken();
    }
    return config;
  },
  (error) => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  });
// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */
  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  (response) => {
    const res = response.data;
    // if the custom code is not 20000, it is judged as an error.
    if (res.code === 401) {
      console.log(res);
      // to re-login
      MessageBox.confirm("登录状态已过期，您可以继续留在该页面，或者重新登录", "系统提示", {
        confirmButtonText: "重新登录",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        store.dispatch("resetToken").then(() => {
          // location.reload();
          router.push('/login')
        });
      });
      // return Promise.reject('无效的会话，或者会话已过期，请重新登录。')
    } else if (res.code !== 200) {
      Message({
        message: res.msg || "Error",
        type: "error",
        duration: 5 * 1000,
      });
      return Promise.reject(new Error(res.msg));
    } else if (res.code === 500) {
      Message({
        message: res.msg,
        type: "error",
      });
      return Promise.reject(new Error(res.msg));
    } else {
      return res;
    }
  },
  (error) => {
    console.log("err" + error); // for debug
    // Message({
    //     message: error.message,
    //     type: "error",
    //     duration: 5 * 1000,
    // });
    return Promise.reject(error);
  });
export default service;